module.exports = __webpack_public_path__ + "static/img/land-img5.1a9b11a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/land-img5.jpg
// module id = 5sfq
// module chunks = 1